// Must be imported first so fetch/XHR are instrumented before any other module can use them.
import './config/tracing';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider } from './app/AppProvider';
import { AppRouter } from './app/AppRouter';
import { registerAppSW } from './register-sw';
import { setupPreloadErrorHandler } from './utils/pwa/preloadErrorHandler';

import './config/amplify';
import './config/i18n';
import './config/sentry';
import './index.css';

setupPreloadErrorHandler();
void registerAppSW();

const root = document.querySelector('#root');
if (!root) throw new Error('No root element found');

createRoot(root).render(
  <StrictMode>
    <AppProvider>
      <AppRouter />
    </AppProvider>
  </StrictMode>,
);
